import React, { Component } from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';
import { Dropdown as BootstrapDropdown } from 'reactstrap';

import './Dropdown.scss';

class Dropdown extends Component {
  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.state = {
      isOpen: false
    };
  }

  toggle() {
    this.setState({
      isOpen: !this.state.isOpen
    });
  }

  render() {
    const { children, className, disabled, ...otherProps } = this.props;
    const { isOpen } = this.state;
    const classProps = cn({ disabled }, className);

    return (
      <BootstrapDropdown
        {...otherProps}
        isOpen={isOpen}
        toggle={this.toggle}
        className={classProps}
      >
        {children}
      </BootstrapDropdown>
    );
  }
}

Dropdown.propTypes = {
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  className: PropTypes.string,
  direction: PropTypes.oneOf(['up', 'down', 'left', 'right']),
  disabled: PropTypes.bool,
  group: PropTypes.bool,
  // For Dropdown usage inside a Navbar (disables popper)
  inNavbar: PropTypes.bool,
  isOpen: PropTypes.bool,
  // For Dropdown usage inside a Nav
  nav: PropTypes.bool,
  tag: PropTypes.string, // default: 'div' unless nav=true, then 'li'
  toggle: PropTypes.func
};

Dropdown.defaultProps = {
  isOpen: false,
  className: ''
};

export default Dropdown;



// WEBPACK FOOTER //
// ./src/components/atoms/Dropdown/Dropdown.js